import React, { useEffect, useState } from "react";
import AdjustTons from "../AdjustTons/AdjustTons";
import TruckDetails from "../TruckDetails/TruckDetails";
import deliveryTruckSvg from "../../../../../../../../Assets/images/delivery-truck_7656486.svg"; // Re-import for cache busting
import trackIcon from "../../../../../../../../Assets/images/track-icon.png";
import trackIconOff from "../../../../../../../../Assets/images/track-black-icon.png";

import apiClient from "../../../../../../../../Config/apiClient";
import { ClipLoader } from "react-spinners";
import { showErrorToast } from "../../../../../../../../Context/Toaster/Toaster";
import moment from "moment";
import "./TruckLists.scss";
import { DATE_FORMAT } from "../../../../../Utils/Constants";

const TruckUrl = process.env.REACT_APP_CC_TRUCK_BASE_PATH;

const TrucksTab = ({ jobId, refresh, jobData }) => {
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTruckDetails, setShowTruckDetails] = useState(false);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [showAdjustTons, setShowAdjustTons] = useState(false);
  const [selectedTruckJob, setSelectedTruckJob] = useState(null);

  useEffect(() => {
    if (jobId) fetchTrucks();
  }, [jobId, refresh]);

  const fetchTrucks = async () => {
    try {
      setLoading(true);
      if (!TruckUrl) throw new Error("TruckUrl is undefined");
      const response = await apiClient.get(`${TruckUrl}/trucks/${jobId}`);
      const data = response.data?.data || [];
      setTrucks(data);
    } catch (error) {
      console.error("Error fetching trucks:", error);
      showErrorToast("Failed to load trucks");
    } finally {
      setLoading(false);
    }
  };

  const openTruckDetails = async (e, truck) => {
    e.preventDefault();
    const truckId = truck?.truckDetails?.truck_id;
    if (!truckId) return showErrorToast("Truck ID not found");

    try {
      setLoading(true);
      const response = await apiClient.get(`${TruckUrl}/details/${truckId}`);
      const detailedTruck = response.data?.data;

      if (!detailedTruck) return showErrorToast("Truck details not found");

      setSelectedTruck({
        ...detailedTruck,
        driverDetails: truck.driverDetails,
        driver: `${truck.driverDetails?.first_name || ""} ${truck.driverDetails?.last_name || ""}`.trim()
      });

      setShowTruckDetails(true);
    } catch (error) {
      console.error("Error fetching truck details:", error);
      showErrorToast("Failed to fetch truck details.");
    } finally {
      setLoading(false);
    }
  };

  const closeTruckDetails = () => {
    setShowTruckDetails(false);
    setSelectedTruck(null);
  };

  const getUnitLabel = (paymentType) => {
    if (paymentType === 2 || paymentType === "Hours" || paymentType === "Hour") return "Hours";
    if (paymentType === 3 || paymentType === "Loads" || paymentType === "Load") return "Loads";
    return "Tons";
  };

  return (
    <>
      <div className="tr-inner">
        <div className="trt-wraper">
          {loading ? (
            <div className="text-center py-4">
              <ClipLoader size={35} />
            </div>
          ) : (
            <table className="table trucks-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Truck ID</th>
                  <th>Driver</th>
                  <th>Driver Status</th>
                  <th>Job Accepted</th>
                  <th className="align-text">Work Done</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {trucks.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No trucks found for this job.
                    </td>
                  </tr>
                ) : (
                  trucks.map((truck, index) => {
                    const truckId = truck.truckDetails?.truck_id;
                    const driverName = `${truck.driverDetails?.first_name || ""} ${truck.driverDetails?.last_name || ""}`.trim();
                    const jobAccepted = moment(truck.applied_datetime).local().format(DATE_FORMAT);
                    const tonsDumped = truck.work_done;
                    
                    // Driver availability: based on whether they started work on this job
                    const driverJobStatus = truck.job_status?.toLowerCase();
                    const isDriverAvailable = ['in_progress', 'started', 'completed'].includes(driverJobStatus);
                    const startedTime = truck.work_start_datetime;

                    const tracked = false;

                    return (
                      <tr key={truck.id}>
                        <td>{index + 1}</td>
                        <td>
                          <a href="#" onClick={(e) => openTruckDetails(e, truck)}>
                            T-{truckId || "--"}
                          </a>
                        </td>
                        <td>
                          <a href="#" onClick={(e) => openTruckDetails(e, truck)}>
                            {driverName || "--"}
                          </a>
                        </td>
                        <td>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            {isDriverAvailable ? (
                              <>
                                <span style={{ color: '#28a745', fontWeight: '600', fontSize: '0.9em' }}>
                                  ● Available
                                </span>
                                {startedTime && (
                                  <span style={{ fontSize: '0.8em', color: '#6c757d' }}>
                                    Started: {moment.utc(startedTime).local().format('hh:mm A')}
                                  </span>
                                )}
                              </>
                            ) : (
                              <span style={{ color: '#6c757d', opacity: 0.6, fontSize: '0.9em' }}>
                                ○ Not Started
                              </span>
                            )}
                          </div>
                        </td>
                        <td>{jobAccepted}</td>
                        <td className="align-text">
                          {tonsDumped != null && !isNaN(tonsDumped)
                            ? `${Number(tonsDumped).toFixed(2)} ${getUnitLabel(jobData?.payment_type)}`
                            : "--"}
                        </td>
                        <td>
                          {(() => {
                            const jobStatus = truck.jobDetails?.job_status;
                            const isdisabled =
                              jobStatus === "Cancelled" ||
                              jobStatus === "Completed" ||
                              jobStatus === "Not Started";

                            return (
                              <a
                                href="#"
                                onClick={(e) => { e.preventDefault();
                                  if (isdisabled) return;
                                  setSelectedTruckJob(truck);
                                  setShowAdjustTons(true);
                                }}
                                style={{ pointerEvents: isdisabled ? "none" : "auto",opacity: isdisabled ? 0.5 : 1, }}
                              >
                                  <img className="tb-icon" src={deliveryTruckSvg} alt="Job Activity Truck SVG" style={{ width: 48, height: 32, minWidth: 48, minHeight: 32, objectFit: 'contain', display: 'block' }} />
                              </a>
                            );
                          })()}
                        </td>
                        <td>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <AdjustTons
        show={showAdjustTons}
        onClose={() => {
          setShowAdjustTons(false);
          setSelectedTruckJob(null);
        }}
        onAdjusted={() => {refresh();}}
        truckJobId={selectedTruckJob?.id}
        jobData={jobData}
        truckDetails={{
          truckId: selectedTruckJob?.truckDetails?.truck_id,
          licensePlate: selectedTruckJob?.truckDetails?.license_plate_no,
          vehicleNumber: selectedTruckJob?.truckDetails?.vehicle_no,
          truckType: selectedTruckJob?.truckDetails?.truck_type,
        }}
        initialWorkDone={selectedTruckJob?.work_done}
      />

      <TruckDetails truck={selectedTruck} show={showTruckDetails} onClose={closeTruckDetails} />
      </>
  );
};

export default TrucksTab;
